// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard {
  background-color: #ffffff;
  border: 0.5px solid #CBCBCB;
  padding-top: 30px;
  position: relative;
}

.dashboard .dashboard-param {
  position: absolute;
    top: -140px;
    margin-bottom: 40px;
}

.dashboard .dashboard-param .nav-pills {
  border-bottom: 0.5px solid #8D8D8D;
  text-align: center;
  justify-content: center;
  align-items: center;
  opacity: 1;
}

.dashboard .dashboard-param .nav-link {
  padding-right: 0;
  background-color: transparent;
}

.dashboard .dashboard-param .nav-link.active {
  background-color: transparent;
  border-bottom: 2px solid #002E5B;
  border-radius: 0;
}

.dashboard .dashboard-param .nav-link.active button {
  color: #2323E5;
}

.dashboard .dashboard-param .nav-link button {
  border: 0;
  color: #8D8D8D;
  background-color: transparent;
  padding-inline: 10px;
}

.dashboard .summary-heading {
  color: #585858;
  font-size: 18px;
  margin-bottom: 10px;
}

.summary-amount {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 0;
}

.success {
  color: #00865A;
}

.count-success {
  color: #041841;
}

.terminal-success {
  color: #133855;
}

.failed {
  color: #FF024B;
  margin-top: 12px;
}

.count-failed {
  color: #7E7E7E;
  margin-top: 12px;
}

.terminal-failed {
  color: #3E729B;
  margin-top: 12px;
}

.failed-percent {
  color: #9A9A9A;
  font-size: 14px;
}

.failed-percent span {
  color: #F23551;
  margin-right: 10px;
}

.success-percent {
  font-size: 14px;
  color: #9A9A9A;
  /* margin-bottom: 22px; */
}

.success-percent span {
  color: #159E94;
  margin-right: 10px;
}


.circle-bar{
    padding-left: 1rem;
  }

.circle-bar-area {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto;
    padding: 20px;
}

.dashboard .CircularProgressbar {
    /* width: 90% !important; */
    vertical-align: middle !important;
}

.dashboard .CircularProgressbar-path {
    stroke-width: 10;
  }

  .dashboard .CircularProgressbar-trail {
    stroke-width: 10;
}

.center-label {
  color: #9A9A9A;;
}

.center-label .amount {
  color: #3E4095;
}

.label {
  display: flex;
  justify-content: flex-start;
  gap: 10px;
  color: #9A9A9A;
  font-size: 12px;
}

.data-label {
  width: 11px;
  height: 12px; 
}

.value {
  background-color: #00865A;
}

.volume {
  background-color: #021623;
}

.terminal {
  background-color: #406A99;
}`, "",{"version":3,"sources":["webpack://./src/view/reporting-dashboard/card-transactions/transaction-dashboard/Dashboard.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;IAChB,WAAW;IACX,mBAAmB;AACvB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;;AAGA;IACI,kBAAkB;EACpB;;AAEF;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,2BAA2B;IAC3B,iCAAiC;AACrC;;AAEA;IACI,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".dashboard {\n  background-color: #ffffff;\n  border: 0.5px solid #CBCBCB;\n  padding-top: 30px;\n  position: relative;\n}\n\n.dashboard .dashboard-param {\n  position: absolute;\n    top: -140px;\n    margin-bottom: 40px;\n}\n\n.dashboard .dashboard-param .nav-pills {\n  border-bottom: 0.5px solid #8D8D8D;\n  text-align: center;\n  justify-content: center;\n  align-items: center;\n  opacity: 1;\n}\n\n.dashboard .dashboard-param .nav-link {\n  padding-right: 0;\n  background-color: transparent;\n}\n\n.dashboard .dashboard-param .nav-link.active {\n  background-color: transparent;\n  border-bottom: 2px solid #002E5B;\n  border-radius: 0;\n}\n\n.dashboard .dashboard-param .nav-link.active button {\n  color: #2323E5;\n}\n\n.dashboard .dashboard-param .nav-link button {\n  border: 0;\n  color: #8D8D8D;\n  background-color: transparent;\n  padding-inline: 10px;\n}\n\n.dashboard .summary-heading {\n  color: #585858;\n  font-size: 18px;\n  margin-bottom: 10px;\n}\n\n.summary-amount {\n  font-size: 16px;\n  font-weight: 600;\n  margin-bottom: 0;\n}\n\n.success {\n  color: #00865A;\n}\n\n.count-success {\n  color: #041841;\n}\n\n.terminal-success {\n  color: #133855;\n}\n\n.failed {\n  color: #FF024B;\n  margin-top: 12px;\n}\n\n.count-failed {\n  color: #7E7E7E;\n  margin-top: 12px;\n}\n\n.terminal-failed {\n  color: #3E729B;\n  margin-top: 12px;\n}\n\n.failed-percent {\n  color: #9A9A9A;\n  font-size: 14px;\n}\n\n.failed-percent span {\n  color: #F23551;\n  margin-right: 10px;\n}\n\n.success-percent {\n  font-size: 14px;\n  color: #9A9A9A;\n  /* margin-bottom: 22px; */\n}\n\n.success-percent span {\n  color: #159E94;\n  margin-right: 10px;\n}\n\n\n.circle-bar{\n    padding-left: 1rem;\n  }\n\n.circle-bar-area {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin: auto;\n    padding: 20px;\n}\n\n.dashboard .CircularProgressbar {\n    /* width: 90% !important; */\n    vertical-align: middle !important;\n}\n\n.dashboard .CircularProgressbar-path {\n    stroke-width: 10;\n  }\n\n  .dashboard .CircularProgressbar-trail {\n    stroke-width: 10;\n}\n\n.center-label {\n  color: #9A9A9A;;\n}\n\n.center-label .amount {\n  color: #3E4095;\n}\n\n.label {\n  display: flex;\n  justify-content: flex-start;\n  gap: 10px;\n  color: #9A9A9A;\n  font-size: 12px;\n}\n\n.data-label {\n  width: 11px;\n  height: 12px; \n}\n\n.value {\n  background-color: #00865A;\n}\n\n.volume {\n  background-color: #021623;\n}\n\n.terminal {\n  background-color: #406A99;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
